import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUtils } from "../../services/utilsProvider";
import { useNews } from "./provider";
import styled from "styled-components";
import FormNews from "./FormNews";
import { Icon } from "../../ui";

const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    line-height: 0;
    svg {
      margin: 0 20px 0 10px;
    }
  }
`;

const EditNews = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { notify } = useUtils();

  const {
    state: { selected: news },
    fetchOne,
    dispatch,
  } = useNews();

  useEffect(() => {
    fetchOne(params.id, { langCode: params.langCode });
    return () => dispatch({ type: "set_selected", payload: null });
  }, [fetchOne, dispatch, params]);

  const handleSuccess = () => {
    navigate(-1);
    notify("Changes saved successfully");
  };

  if (!news || news.id !== Number(params.id)) return;
  return (
    <div id="edit-newS">
      <Grid>
        <h2 style={{ marginTop: "0" }}>Edit News</h2>
        <div style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          <span>Back</span>
          <Icon name="arrowLeft" />
        </div>
      </Grid>
      <FormNews news={news} handleSuccess={handleSuccess} />
    </div>
  );
};

export default EditNews;
